export default __webpack_public_path__ + "static/media/A Warm Heart.3784e076.png";